import { useMutation } from '@apollo/client'
import { REMOVE_COMPANY_GROUP } from './operations'
import { RemoveCompanyGroup, RemoveCompanyGroupVariables } from '../../types'

export const useRemoveCompanyGroup = () =>
  useMutation<RemoveCompanyGroup, RemoveCompanyGroupVariables>(REMOVE_COMPANY_GROUP)
